import React, { useState } from "react";
import styled from "styled-components";
import ToolsMenuList from "./ToolsMenuList";
import TranslateComponent from "../Translate/TranslateComponent";
import PresentationTranslationToolPage from "../../Pages/PresentationTranslationToolPage";
import VideoTranslationToolPage from "../../Pages/VideoTranslationToolPage";
import ConversationTranslationPage from "../../Pages/ConversationTranslationPage";
import LiveFeedPage from "../../Pages/LiveFeedPage";
import { TOOLS_TRANSLATE, TOOLS_PRESENTATIONS, TOOLS_VIDEO_TRANSLATION, TOOLS_CONVERSATION, TOOLS_LIVE_FEED } from "../../Constants/constantValues";

const ToolsMenu = ({
  translationHistory,
  setTranslationHistory,
  setLoading,
  fromLanguage,
  setFromLanguage,
  toLanguage,
  setToLanguage,
  from,
  setFrom,
  initialCategory,
}) => {
  const [displayCategory, setDisplayCategory] = useState(initialCategory || TOOLS_TRANSLATE);

  return (
    <ToolsContainer>
      <ToolsMenuList
        displayCategory={displayCategory}
        setDisplayCategory={setDisplayCategory}
      />
      
      <ContentWrapper>
        {displayCategory === TOOLS_CONVERSATION && (
          <ConversationTranslationPage />
        )}
        
        {displayCategory === TOOLS_LIVE_FEED && (
          <LiveFeedPage />
        )}
        
        {displayCategory === TOOLS_TRANSLATE && (
          <TranslateComponent
            translationHistory={translationHistory}
            setTranslationHistory={setTranslationHistory}
            setLoading={setLoading}
            fromLanguage={fromLanguage}
            setFromLanguage={setFromLanguage}
            toLanguage={toLanguage}
            setToLanguage={setToLanguage}
            from={from}
            setFrom={setFrom}
          />
        )}
        
        {displayCategory === TOOLS_PRESENTATIONS && (
          <PresentationTranslationToolPage />
        )}
        
        {displayCategory === TOOLS_VIDEO_TRANSLATION && (
          <VideoTranslationToolPage />
        )}
      </ContentWrapper>
    </ToolsContainer>
  );
};

export default ToolsMenu;

const ToolsContainer = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  flex: 1;
  background: ${({ theme }) => theme.menu.background};
`;

const ContentWrapper = styled.div`
  flex: 1;
  height: 100%;
  width: 100%;
  position: relative;
`;